import { AD } from "./i18n";

export function startLanding(root) {
    if (!root) {
        return () => {};
    }

    const copy = AD.copy;
    const bootLines = AD.bootLines;
    const listeners = [];
    const intervals = [];
    const observers = [];

    const on = (target, type, handler, options) => {
        target.addEventListener(type, handler, options);
        listeners.push([target, type, handler, options]);
    };

    const skillsHere = () => true;

    let lang = "lt";
    const boot = root.querySelector("[data-boot]");
    const log = root.querySelector("[data-boot-log]");
    const bar = root.querySelector("[data-boot-bar]");
    const skip = root.querySelector("[data-skip]");
    const chrome = root.querySelector("[data-chrome]");
    const glow = root.querySelector("[data-glow]");
    const giant = root.querySelector("[data-giant]");
    const year = root.querySelector("[data-year]");
    const clock = root.querySelector("[data-clock]");

    const paintChrome = () => {
        if (!chrome) {
            return;
        }
        chrome.innerHTML = `
            <a class="top__brand" href="/">
                <img class="top__logo" src="${process.env.PUBLIC_URL || ""}/logo192.png" alt="">
                AntiusDragon
            </a>
            <nav class="top__nav" aria-label="AntiusDragon">
                <!-- Produktai (OS, Open Folder, Plant Plan): atkomentuoti tik kai paprašys — projektai dar nebaigti.
                <a href="https://os.antiusdragon.com" target="_blank" rel="noopener noreferrer" data-i18n="nav.os">OS</a>
                <a href="https://open-folder.antiusdragon.com" target="_blank" rel="noopener noreferrer" data-i18n="nav.folder">Open Folder</a>
                <a href="https://plantplan.antiusdragon.com" target="_blank" rel="noopener noreferrer" data-i18n="nav.plant">Plant Plan</a>
                -->
                <a href="#paslaugos" class="${skillsHere() ? "is-here" : ""}" data-scroll="paslaugos" data-i18n="nav.skills">Paslaugos</a>
            </nav>
            <div class="top__right">
                <button class="lang" type="button" data-lang-toggle>EN</button>
                <a class="pill" href="#kontaktai" data-scroll="kontaktai" data-i18n="nav.contact">Kontaktai</a>
            </div>
        `;
    };

    paintChrome();

    if (year) {
        year.textContent = String(new Date().getFullYear());
    }

    const applyLang = () => {
        document.documentElement.lang = lang;
        root.querySelectorAll("[data-i18n]").forEach((el) => {
            const text = copy[lang][el.getAttribute("data-i18n")];
            if (text) {
                el.textContent = text;
            }
        });
        const langBtn = root.querySelector("[data-lang-toggle]");
        if (langBtn) {
            langBtn.textContent = lang === "lt" ? "EN" : "LT";
        }
    };

    const scrollToId = (id) => {
        const target = root.querySelector(`#${id}`);
        if (target) {
            target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    on(root, "click", (e) => {
        if (e.target.closest("[data-lang-toggle]")) {
            lang = lang === "lt" ? "en" : "lt";
            applyLang();
            return;
        }
        const jump = e.target.closest("[data-scroll]");
        if (jump && root.contains(jump)) {
            e.preventDefault();
            scrollToId(jump.getAttribute("data-scroll"));
        }
    });

    const tickClock = () => {
        if (!clock) {
            return;
        }
        clock.textContent = new Date().toLocaleTimeString(lang === "en" ? "en-GB" : "lt-LT", {
            hour: "2-digit",
            minute: "2-digit",
        });
    };

    tickClock();
    intervals.push(setInterval(tickClock, 15000));

    let booted = false;
    const finishBoot = () => {
        if (booted || !boot) {
            return;
        }
        booted = true;
        boot.classList.add("is-done");
    };

    let bootTimer = null;
    const runBoot = () => {
        if (!boot) {
            return;
        }
        const lines = bootLines[lang];
        let i = 0;
        bootTimer = setInterval(() => {
            if (!log || i >= lines.length) {
                clearInterval(bootTimer);
                bootTimer = null;
                if (bar) {
                    bar.style.width = "100%";
                }
                setTimeout(finishBoot, 320);
                return;
            }
            const li = document.createElement("li");
            li.innerHTML = `${lines[i][0]} <b>${lines[i][1]}</b>`;
            log.appendChild(li);
            if (bar) {
                bar.style.width = `${((i + 1) / lines.length) * 100}%`;
            }
            i += 1;
        }, 240);
        intervals.push(bootTimer);
    };

    skip?.addEventListener("click", finishBoot);
    on(window, "keydown", (e) => {
        if (boot && !boot.classList.contains("is-done") && (e.key === "Escape" || e.key === "Enter")) {
            finishBoot();
        }
    });

    runBoot();
    applyLang();

    const hoverFine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    if (hoverFine) {
        on(window, "pointermove", (e) => {
            if (glow) {
                glow.style.left = `${e.clientX}px`;
                glow.style.top = `${e.clientY}px`;
            }
            if (giant) {
                const x = (e.clientX / window.innerWidth - 0.5) * 24;
                const y = (e.clientY / window.innerHeight - 0.5) * 16;
                giant.style.transform = `translate(calc(-50% + ${x}px), calc(-54% + ${y}px))`;
            }
        });
    }

    const skillsWin = root.querySelector('[data-win="skills"]');
    const film = skillsWin?.querySelector("nav.film");
    const originals = film ? [...film.querySelectorAll(".still")] : [];
    const skillIds = originals.map((el) => el.getAttribute("data-app"));
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const phoneQ = window.matchMedia("(max-width: 980px)");
    const isPhone = () => phoneQ.matches;
    const PHOTO_MS = 3200;
    const setCount = originals.length;

    if (film && setCount) {
        originals.forEach((el) => film.appendChild(el.cloneNode(true)));
        originals.forEach((el) => film.appendChild(el.cloneNode(true)));
    }

    const paneShots = (id) => skillsWin?.querySelector(`[data-pane="${id}"] [data-shots]`);

    const paintSlide = (shotsRoot, index) => {
        if (!shotsRoot) {
            return 0;
        }
        const slides = [...shotsRoot.querySelectorAll(".view__shot")];
        const dots = [...shotsRoot.querySelectorAll("[data-dot]")];
        if (!slides.length) {
            return 0;
        }
        const i = (index + slides.length) % slides.length;
        slides.forEach((slide, n) => slide.classList.toggle("is-on", n === i));
        dots.forEach((dot, n) => {
            dot.classList.toggle("is-on", n === i);
            if (n === i) {
                dot.setAttribute("aria-current", "true");
            } else {
                dot.removeAttribute("aria-current");
            }
        });
        return i;
    };

    const setWidth = () => {
        if (!film || !setCount) {
            return 0;
        }
        const stills = [...film.querySelectorAll(".still")];
        if (stills.length < setCount + 1) {
            return 0;
        }
        return stills[setCount].offsetLeft - stills[0].offsetLeft;
    };

    let filmJumping = false;
    let filmDrag = false;
    let wrapUnlock = 0;

    const lockFilm = (ms = 120) => {
        filmJumping = true;
        window.clearTimeout(wrapUnlock);
        wrapUnlock = window.setTimeout(() => {
            filmJumping = false;
        }, ms);
    };

    const wrapFilm = () => {
        if (!film || filmJumping || !isPhone()) {
            return;
        }
        const w = setWidth();
        if (!w) {
            return;
        }
        if (film.scrollLeft < w * 0.5) {
            lockFilm();
            film.scrollLeft += w;
        } else if (film.scrollLeft > w * 1.5) {
            lockFilm();
            film.scrollLeft -= w;
        }
    };

    const filmCenter = (id, dir = 0, instant = false) => {
        if (!film || !id || !isPhone()) {
            return;
        }
        wrapFilm();
        const midX = film.scrollLeft + film.clientWidth / 2;
        const candidates = [...film.querySelectorAll(`.still[data-app="${id}"]`)];
        if (!candidates.length) {
            return;
        }
        let pick = candidates[0];
        if (dir > 0) {
            pick =
                candidates.find((el) => el.offsetLeft + el.offsetWidth / 2 > midX + 10) ||
                candidates[candidates.length - 1];
        } else if (dir < 0) {
            pick =
                [...candidates].reverse().find((el) => el.offsetLeft + el.offsetWidth / 2 < midX - 10) ||
                candidates[0];
        } else {
            pick = candidates.reduce((best, el) => {
                const c = el.offsetLeft + el.offsetWidth / 2;
                const b = best.offsetLeft + best.offsetWidth / 2;
                return Math.abs(c - midX) < Math.abs(b - midX) ? el : best;
            });
        }
        const left = pick.offsetLeft - film.clientWidth / 2 + pick.offsetWidth / 2;
        film.scrollTo({ left, behavior: instant || reducedMotion ? "auto" : "smooth" });
        if (instant) {
            wrapFilm();
        } else {
            window.setTimeout(wrapFilm, 420);
        }
    };

    const filmStills = film ? [...film.querySelectorAll(".still")] : [];

    const nearestFilmSkill = () => {
        if (!film || !filmStills.length) {
            return skillIds[0];
        }
        const midX = film.scrollLeft + film.clientWidth / 2;
        let best = filmStills[0];
        let bestD = Infinity;
        for (let i = 0; i < filmStills.length; i += 1) {
            const el = filmStills[i];
            const d = Math.abs(el.offsetLeft + el.offsetWidth * 0.5 - midX);
            if (d < bestD) {
                bestD = d;
                best = el;
            }
        }
        return best.getAttribute("data-app");
    };

    let activeId = skillIds[0] || "web";

    const openSkill = (id, dir = 0, moveFilm = true, cut = false) => {
        if (!skillsWin || !id) {
            return;
        }
        if (id !== activeId) {
            activeId = id;
            for (let i = 0; i < filmStills.length; i += 1) {
                const still = filmStills[i];
                still.classList.toggle("is-on", still.getAttribute("data-app") === id);
            }
            skillsWin.querySelectorAll(".rail [data-app]").forEach((btn) => {
                btn.classList.toggle("is-on", btn.getAttribute("data-app") === id);
            });
            skillsWin.querySelectorAll("[data-pane]").forEach((pane) => {
                pane.classList.toggle("is-on", pane.getAttribute("data-pane") === id);
            });
            skillsWin.querySelectorAll("[data-copy]").forEach((block) => {
                const onCopy = block.getAttribute("data-copy") === id;
                block.classList.toggle("is-on", onCopy);
                block.setAttribute("aria-hidden", onCopy ? "false" : "true");
            });
            const shotsRoot = paneShots(id);
            if (shotsRoot) {
                if (cut) {
                    shotsRoot.classList.add("is-cut");
                }
                paintSlide(shotsRoot, 0);
                if (cut) {
                    shotsRoot.classList.remove("is-cut");
                }
            }
        }
        if (moveFilm && isPhone()) {
            filmCenter(id, dir);
        }
    };

    const currentSkill = () => activeId;

    let autoTimer = null;
    let autoArmed = true;

    const stopAuto = () => {
        if (autoTimer) {
            clearInterval(autoTimer);
            autoTimer = null;
        }
    };

    const stepAuto = () => {
        if (!skillsWin) {
            return;
        }
        const id = currentSkill();
        const shotsRoot = paneShots(id);
        if (!shotsRoot) {
            return;
        }
        const slides = [...shotsRoot.querySelectorAll(".view__shot")];
        const now = slides.findIndex((slide) => slide.classList.contains("is-on"));
        if (now < slides.length - 1) {
            paintSlide(shotsRoot, now + 1);
            return;
        }
        const nextId = skillIds[(Math.max(0, skillIds.indexOf(id)) + 1) % skillIds.length];
        openSkill(nextId, 1, true, true);
    };

    const startAuto = () => {
        stopAuto();
        if (reducedMotion || !skillsWin || !autoArmed) {
            return;
        }
        autoTimer = setInterval(stepAuto, PHOTO_MS);
    };

    const paslaugos = root.querySelector("#paslaugos");
    if (paslaugos && skillsWin) {
        const see = new IntersectionObserver(
            (entries) => {
                autoArmed = entries.some((entry) => entry.isIntersecting);
                if (autoArmed) {
                    startAuto();
                } else {
                    stopAuto();
                }
            },
            { threshold: 0.28 }
        );
        see.observe(paslaugos);
        observers.push(see);
    }

    on(document, "visibilitychange", () => {
        if (document.hidden) {
            stopAuto();
        } else if (autoArmed) {
            startAuto();
        }
    });

    skillsWin?.querySelectorAll(".rail [data-app]").forEach((btn) => {
        btn.addEventListener("click", () => {
            openSkill(btn.getAttribute("data-app"), 0, false, true);
            startAuto();
        });
    });

    film?.addEventListener("click", (e) => {
        const still = e.target.closest(".still[data-app]");
        if (!still || !film.contains(still)) {
            return;
        }
        e.preventDefault();
        if (filmDrag) {
            filmDrag = false;
            return;
        }
        const id = still.getAttribute("data-app");
        openSkill(id, 0, false, true);
        if (isPhone()) {
            filmCenter(id, 0);
        }
        startAuto();
    });

    let filmScrollWait = 0;
    film?.addEventListener(
        "scroll",
        () => {
            if (!isPhone()) {
                return;
            }
            wrapFilm();
            if (filmJumping) {
                return;
            }
            const id = nearestFilmSkill();
            if (id && id !== activeId) {
                openSkill(id, 0, false, true);
            }
            window.clearTimeout(filmScrollWait);
            stopAuto();
            filmScrollWait = window.setTimeout(startAuto, 200);
        },
        { passive: true }
    );

    film?.addEventListener("pointerdown", () => {
        filmDrag = false;
    });
    film?.addEventListener("pointermove", (e) => {
        if (e.buttons) {
            filmDrag = true;
        }
    });

    const parkFilm = (instant = true) => {
        if (!isPhone()) {
            if (film) {
                film.scrollLeft = 0;
            }
            return;
        }
        const w = setWidth();
        if (!w || !film) {
            return;
        }
        lockFilm(160);
        film.scrollLeft = w;
        filmCenter(currentSkill(), 0, instant);
    };

    let parkWidth = window.innerWidth;
    on(window, "load", () => parkFilm(true));
    on(window, "resize", () => {
        const width = window.innerWidth;
        if (width === parkWidth) {
            return;
        }
        parkWidth = width;
        parkFilm(true);
    });
    window.requestAnimationFrame(() => parkFilm(true));

    root.querySelectorAll("[data-shots]").forEach((shotsRoot) => {
        const slides = [...shotsRoot.querySelectorAll(".view__shot")];
        const dots = [...shotsRoot.querySelectorAll("[data-dot]")];
        let startX = null;
        let swiped = false;

        const go = (index) => {
            paintSlide(shotsRoot, index);
            startAuto();
        };

        dots.forEach((dot, i) => {
            dot.addEventListener("click", (e) => {
                e.stopPropagation();
                go(i);
            });
        });

        shotsRoot.addEventListener("click", (e) => {
            if (swiped || e.target.closest("[data-dot]")) {
                swiped = false;
                return;
            }
            const current = slides.findIndex((slide) => slide.classList.contains("is-on"));
            go(current + 1);
        });

        shotsRoot.addEventListener("pointerdown", (e) => {
            startX = e.clientX;
            swiped = false;
        });

        shotsRoot.addEventListener("pointerup", (e) => {
            if (startX == null) {
                return;
            }
            const dx = e.clientX - startX;
            startX = null;
            if (Math.abs(dx) < 40) {
                return;
            }
            swiped = true;
            const current = slides.findIndex((slide) => slide.classList.contains("is-on"));
            go(current + (dx < 0 ? 1 : -1));
        });

        if (hoverFine) {
            shotsRoot.addEventListener("pointerenter", stopAuto);
            shotsRoot.addEventListener("pointerleave", startAuto);
        }
    });

    const dockLinks = [...root.querySelectorAll("[data-dock]")];
    if (dockLinks.length) {
        const dockMap = {
            paslaugos: root.querySelector("#paslaugos"),
            produktai: root.querySelector("#produktai"),
            kontaktai: root.querySelector("#kontaktai"),
        };
        const markDock = (id) => {
            dockLinks.forEach((link) => {
                link.classList.toggle("is-on", link.getAttribute("data-dock") === id);
            });
        };
        const dockWatch = new IntersectionObserver(
            (entries) => {
                const seen = entries
                    .filter((entry) => entry.isIntersecting)
                    .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
                if (seen) {
                    markDock(seen.target.id);
                }
            },
            { rootMargin: "-20% 0px -55% 0px", threshold: [0.15, 0.4, 0.7] }
        );
        Object.values(dockMap).forEach((section) => {
            if (section) {
                dockWatch.observe(section);
            }
        });
        observers.push(dockWatch);
        dockLinks.forEach((link) => {
            link.addEventListener("click", () => markDock(link.getAttribute("data-dock")));
        });
    }

    return () => {
        finishBoot();
        stopAuto();
        if (bootTimer) {
            clearInterval(bootTimer);
        }
        intervals.forEach((id) => clearInterval(id));
        listeners.forEach(([target, type, handler, options]) => {
            target.removeEventListener(type, handler, options);
        });
        observers.forEach((observer) => observer.disconnect());
        window.clearTimeout(filmScrollWait);
        window.clearTimeout(wrapUnlock);
    };
}
